import axios from "axios";
import resolve from "./../resolver.js";
import checkJwt from "./../../Global/jwtChecker";
import logout from "./../../Global/logout";
import { v4 as uuid_v4 } from "uuid";

export default async function PostClientFiscalization(
    device,
    sredstvoPlacanja,
    artikli
) {
    const unHashedJwt = await checkJwt();
    if (!unHashedJwt) {
        logout();
    }

    let formatiraniArtikli = [];
    artikli.map((data) =>
        formatiraniArtikli.push({
            uuid: uuid_v4(),
            ukupni_iznos: parseFloat(data.ukupni_iznos),
            kolicina: parseInt(data.ukupni_iznos < 0 ? -1 : 1),
            jedinicna_cijena_mpc: parseFloat(
                data.ukupni_iznos < 0
                    ? parseFloat(data.ukupni_iznos) * -1
                    : parseFloat(data.ukupni_iznos)
            ),
            artikl: data.uuid,
        })
    );

    return await resolve(
        axios("client/fiscalization/" + device.value, {
            method: "post",
            headers: { Authorization: unHashedJwt.data },
            data: {
                uuid: uuid_v4(),
                sredstva_placanja: [sredstvoPlacanja.value],
                artikli: formatiraniArtikli,
            },
        })
            .then((res) => res)
            .catch((error) => error.response.data),
        "Client"
    );
}
